import './styles/index.css';

import { App } from 'App';
import * as React from 'react';
import * as ReactDOM from 'react-dom';

const mountNode = document.getElementById('app');
ReactDOM.render(<App />, mountNode);
